import { render, staticRenderFns } from "./PromotionHeader.vue?vue&type=template&id=a9dc8898"
import script from "./PromotionHeader.vue?vue&type=script&lang=js"
export * from "./PromotionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports